import { Box, BoxProps, ColorOptions, Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { FlatList } from 'react-native-gesture-handler'
import { AccordionList } from '../../comps/AccordionList'
import { Modal } from '../../comps/Modal'
import { ModalHeader } from '../../comps/ModalHeader'
import { useStores } from '../../data/store'
import { convertHexToRGBA, formatAmount } from '../../utils'
import { EMI_SCHME_TYPE } from '../../utils/constants'

export interface EMIDetailsModal {
  shouldShow: boolean
  data: any
}

const EMIPlans: FC<{ plans: any }> = ({ plans }: { plans: any }) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))
  const [emiDetailsModalData, setEmiDetailsModalData] = useState<EMIDetailsModal>({ shouldShow: false, data: [] })
  const style = styles(theme)

  const renderHeader = ({ item }: any) => {
    return (
      <>
        <Box {...style.listItemHeading}>
          <Text {...style.headerText}>{item.header.emiBankName}</Text>
          <Icon
            id={item.isExpanded ? 'ARROW_UP' : 'ARROW_DOWN'}
            size={16}
            color={item.isExpanded ? (theme.brandColor as ColorOptions) : (theme.bodyTextColor as ColorOptions)}
          />
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }

  const brandRenderData = (item: any) => {
    console.log('brandRenderData', item)
    return (
      <>
        <Box {...style.noCostListData}>
          <Box {...style.row}>
            <Text {...style.allEMIPlansData}>{item.val}</Text>
            <Text {...style.allEMIPlansData}>{`Payable: ₹${formatAmount(item.amount)}`}</Text>
          </Box>
          <Spacer direction="vertical" size={10} />
          <Box {...style.row}>
            {item.instantDiscountPercentage && item.instantDiscountPercentage > 0 && (
              <Text {...style.discountText}>{'₹' + item.instantDiscountPercentage} Instant Discount applicable</Text>
            )}
            {item.emiDetails && item.emiDetails.length > 0 && (
              <Box
                testID="show-details"
                onPress={() => setEmiDetailsModalData({ shouldShow: true, data: item })}
                borderBottomWidth={1}
                underlayColor={convertHexToRGBA(theme.brandColor, 10) as ColorOptions}
                paddingBottom={4}
                borderBottomColor={theme.brandColor as ColorOptions}>
                <Text {...style.discountText}>Show Details</Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }

  const nonBrandRenderData = (item: any) => {
    return (
      <>
        <Box {...style.listData}>
          <Box>
            <Text {...style.allEMIPlansData}>{item.val}</Text>
            <Spacer size={5} />
            {item.isOfferEligible && <Text {...style.emiOffer}>EMI Offer Applicable</Text>}
          </Box>

          <Text {...style.allEMIPlansData}>{`Payable: ₹${formatAmount(item.amount)}`}</Text>
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }

  const renderData = ({ item }: any) => {
    if (item.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
      console.log('brandRenderData', item)
      return brandRenderData(item)
    } else {
      return nonBrandRenderData(item)
    }
  }

  const emiDetailRowItem = (title: any, value: any, textColor: any) => {
    return (
      <Box flexDirection="row" justifyContent="space-between" pv={8}>
        <Text color={convertHexToRGBA(textColor, 50) as ColorOptions} fontFamily="jioType-medium" fontSize={12}>
          {title}
        </Text>
        <Text color={textColor as ColorOptions} fontFamily="jioType-bold" fontSize={12}>
          {value}
        </Text>
      </Box>
    )
  }
  const renderEMIDetailItem = ({ item }: any) => {
    console.log('renderEMIDetailItem', item)
    return (
      <Box marginTop={8} marginBottom={16} ph={24}>
        {emiDetailRowItem('Product Code', item.productCode, theme?.bodyTextColor)}
        {emiDetailRowItem('Item Value', '₹' + formatAmount(item.itemValue), theme?.bodyTextColor)}
        {emiDetailRowItem('Interest (charge by bank)', '₹' + formatAmount(item.interest), theme?.bodyTextColor)}
        {emiDetailRowItem('EMI Discount/Cashback', '₹' + formatAmount(item.emiDiscount), theme?.bodyTextColor)}
        {item.additionalCashback && emiDetailRowItem('add. Cashback', item.additionalCashback, theme?.bodyTextColor)}
      </Box>
    )
  }
  if (plans?.length === 0) {
    return (
      <Box f={1} justifyContent="center" align="center" backgroundColor={theme.bodyBgColor as ColorOptions}>
        <Text fontSize={12} color={theme.bodyTextColor as ColorOptions}>
          No plans available
        </Text>
      </Box>
    )
  }
  return (
    <>
      <Box backgroundColor={theme.bodyBgColor as ColorOptions} f={1}>
        <AccordionList theme={theme} data={plans} renderHeader={renderHeader} renderData={renderData} />
        <Modal
          type={'BottomTop'}
          headerType="White_Bg"
          show={emiDetailsModalData.shouldShow}
          onDismiss={() => {
            setEmiDetailsModalData({ shouldShow: false, data: {} })
          }}
          isFullWidth={true}
          theme={theme}
          containerTopPadding={'70%'}>
          <Box
            borderTopLeftRadius={16}
            borderTopRightRadius={16}
            backgroundColor={theme.bodyBgColor as ColorOptions}
            height="100%">
            <ModalHeader
              title="EMI Plan"
              onDismiss={() => {
                setEmiDetailsModalData({ shouldShow: false, data: [] })
              }}
              theme={theme}
            />

            <FlatList data={emiDetailsModalData.data.emiDetails} renderItem={renderEMIDetailItem} />

            <Box
              borderTopColor={theme.bodyTextColor as ColorOptions}
              marginBottom={24}
              marginHorizontal={24}
              paddingTop={16}
              marginTop={8}
              flexDirection="row"
              justifyContent="space-between"
              borderTopWidth={1}>
              <Text {...style.totalPayable}>Total Payable</Text>
              <Text {...style.totalPayableAmount}>{`₹${formatAmount(emiDetailsModalData.data.amount)}`}</Text>
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  )
}
const styles = (theme: any) => ({
  headerText: {
    fontSize: 12,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
    textAlign: 'center',
  } as TextProps,
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  discountText: {
    color: theme.brandColor,
    fontSize: 10,
    fontFamily: 'jioType-bold',
    fontWeight: '700',
  } as TextProps,
  noCostListData: {
    padding: 16,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 5) as ColorOptions,
    flexDirection: 'column',
    justifyContent: 'space-between',
  } as BoxProps,
  listItemHeading: {
    height: 56,
    paddingVertical: 20,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.bodyBgColor as ColorOptions,
    alignItems: 'center',
  } as BoxProps,
  emiOffer: {
    fontSize: 10,
    fontWeight: 'bold',
    color: theme?.brandColor as ColorOptions,
  } as TextProps,
  allEMIPlansData: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  headerCardText: {
    fontSize: 12,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
    textAlign: 'center',
  } as TextProps,
  listData: {
    padding: 16,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 5) as ColorOptions,
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  totalPayable: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  totalPayableAmount: {
    fontSize: 14,
    color: theme?.brandColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
})

export { EMIPlans }
